export default __webpack_public_path__ + "static/media/LEVEL9.9bec82af.png";